import script from "./Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Page.vue?vue&type=script&setup=true&lang=js"

import "./Page.vue?vue&type=style&index=0&id=f0686dda&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0686dda"]])

export default __exports__